// module
import * as R from 'ramda'
// actions
import {
  dispatchSetConnectionStatus,
  dispatchSetLoaded,
} from '$comp/main/root.action'
// import { dispatchWappWorkerRegisterAll } from '../../logic/wappWorker/wappWorker.action'
// views
// helpers
import {
  checkBrowserCompatibility,
  checkNeedInstallTwaModal,
  checkRecommendUpdateTwa,
  checkBrowserNotificationPermission,
} from '$logic/client-device'
import afterSignIn from '$hooks/after/signin'
import { isLoggedIn } from '$logic/auth'
import { initiateRouterListener } from '$logic/router/listener'
import { checkClockMismatch } from '$comp/modals/permission-dialog'
import { updateTwaPermissions } from '$logic/twaCommunication'
import { initializeRoomScrolls } from '$logic/room-last-scroll'
import setMicPermission from '../../helper/functions/mediaPermission'
import { checkConnectionWithTWA } from '$logic/twaCommunication/websocket'
import { sendPersistedAnalytics } from '$logic/analytics'
import store, { reduxMainStateKey } from '$setup/redux'
import { lastOpenedRoomMessagesService } from '$logic/last-opened-room-messages/service'
import { lastOpenedRoomsStorageKey } from '$logic/last-opened-room-messages/storage'
import { isInWebView } from '$func/environmentInfo'

export default () => {
  dispatchSetLoaded(true)
  void sendPersistedAnalytics()

  if (isLoggedIn()) {
    dispatchSetConnectionStatus('connecting')
    afterSignIn()
  } else dispatchSetConnectionStatus('signing in')

  // TODO[router]: Why setTimeout is needed?
  setTimeout(() => {
    if (!isInWebView) setMicPermission() // NOTE-WEBVIEW: Webview handles permission in itself

    initiateRouterListener()

    updateTwaPermissions()
    checkConnectionWithTWA()
    checkClockMismatch()
    checkRecommendUpdateTwa()
    checkNeedInstallTwaModal()
    checkBrowserCompatibility()
    checkBrowserNotificationPermission()
  }, 0)

  void initializeRoomScrolls()

  // setInterval(() => {
  //   saveWhenIdle()
  // }, 8000) // Checking idle state every 5 seconds
}

const saveToLocalStorage = () => {
  const state = store.getState()
  const lastOpenedRoomMessages =
    lastOpenedRoomMessagesService.getLastOpenedRoomMessageStore()
  localStorage.setItem(
    reduxMainStateKey,
    JSON.stringify(
      R.assoc(lastOpenedRoomsStorageKey, lastOpenedRoomMessages, state.main),
    ),
  )
}

const saveWhenIdle = () => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(
      () => {
        saveToLocalStorage()
      },
      { timeout: 2000 },
    )
  } else setTimeout(saveToLocalStorage, 5000)
}
